import { socket } from '../core/socket.js';
import { state } from '../core/state.js';
import { t } from '../core/i18n.js';
import { popToast, chaosNotify } from '../utils/alerts.js';
import { armerAutoRetour, annulerAutoRetour } from '../core/statusAutoRetour.js';

export function toggleFlyout(event) {
    if (event) event.stopPropagation();
    const flyout = document.querySelector('.orb-menu-flyout');
    if (!flyout) return;
    
    flyout.classList.toggle('pinned');
    if (!flyout.classList.contains('pinned')) {
        const picker = document.getElementById('status-picker');
        if (picker) picker.style.display = 'none';
    }
}

let _statusCloseTimer = null;

function _startStatusClose(picker) {
    clearTimeout(_statusCloseTimer);
    _statusCloseTimer = setTimeout(() => { picker.style.display = 'none'; }, 350);
}
function _cancelStatusClose() {
    clearTimeout(_statusCloseTimer);
}

export function toggleStatusPicker(event) {
    if (event) {
        event.preventDefault();
        event.stopPropagation();
    }
    const picker = document.getElementById('status-picker');
    if (!picker) return;
    const sourceBtn = event ? event.currentTarget : document.getElementById('self-avatar');
    if (!sourceBtn) return;

    if (picker.style.display === 'none' || picker.style.display === '') {
        picker.style.display = 'block';
        const rect = sourceBtn.getBoundingClientRect();
        const pickerHeight = picker.offsetHeight;
        const buttonCenterY = rect.top + (rect.height / 2);

        picker.style.top = (buttonCenterY - (pickerHeight / 2)) + "px";
        picker.style.left = (rect.right + 15) + "px";

        // Auto-fermeture au mouseleave (avec délai pour permettre
        // de glisser du bouton vers le picker sans qu'il se ferme)
        picker.onmouseleave  = () => _startStatusClose(picker);
        picker.onmouseenter  = _cancelStatusClose;
        sourceBtn.onmouseleave = () => _startStatusClose(picker);
        sourceBtn.onmouseenter = _cancelStatusClose;
    } else {
        picker.style.display = 'none';
    }
}

export function changerStatut(nouveauStatut) {
    const pseudo = window.monPseudo || state.monPseudo;
    if (!pseudo) return console.error("❌ Pseudo introuvable !");

    const inputColor = document.getElementById('edit-color');
    const couleurEnvoi = inputColor ? inputColor.value : "#58a6ff";
    const bioEnvoi = document.getElementById('edit-bio')?.value || "";

    const payload = { 
        pseudo: pseudo, 
        statut: nouveauStatut,
        couleur_preferee: couleurEnvoi,
        bio: bioEnvoi
    };

    socket.emit('update-profile', payload);
    const picker = document.getElementById('status-picker');
    if (picker) picker.style.display = 'none';

    annulerAutoRetour();

    setTimeout(() => {
        socket.emit('get-user-profile', pseudo);
    }, 100);
}

// Appelé depuis le sous-menu du picker (minutesOuNull = durée en minutes, null = pour toujours)
export function changerStatutAvecDuree(statut, minutesOuNull) {
    changerStatut(statut);
    armerAutoRetour(minutesOuNull);
}

export async function supprimerCompte() {
    const pseudo = window.monPseudo || state.monPseudo;

    const ok1 = await chaosNotify(
        t('params.delete_account_confirm1', { pseudo }),
        t('params.delete_account_confirm1_title'),
        'confirm'
    );
    if (!ok1) return;

    const ok2 = await chaosNotify(
        t('params.delete_account_confirm2'),
        t('params.delete_account_confirm2_title'),
        'confirm'
    );
    if (!ok2) return;

    socket.emit('supprimer-compte');
}

export function revoquerAppareil(sessionId) {
    socket.emit('revoquer-appareil', { sessionId });
}

export function revoquerTousAppareils() {
    if (!confirm(t('params.appareils_revoke_all_confirm') || 'Déconnecter tous les autres appareils ?')) return;
    socket.emit('revoquer-tous-appareils');
}

export function enregistrerNomAffiche() {
    const champ = document.getElementById('edit-nom-affiche');
    const msg = document.getElementById('nom-affiche-msg');
    if (!champ) return;
    const val = champ.value.trim();
    if (msg) { msg.style.color = '#8b949e'; msg.textContent = 'Enregistrement…'; }
    socket.emit('changer-nom-affiche', val);
}

export function enregistrerProfilAjuste() {
    const elBio = document.getElementById('edit-bio');
    const elColor = document.getElementById('edit-color');
    const elBanner = document.getElementById('edit-banner');
    const pseudo = window.monPseudo || state.monPseudo;

    const payload = {
        pseudo: pseudo,
        bio: elBio ? elBio.value : "",
        couleur_preferee: elColor ? elColor.value : "#58a6ff",
        banniere_id: elBanner ? elBanner.value : ""
    };

    const btn = document.getElementById('save-settings');
    if (btn) {
        btn.disabled = true;
        btn.classList.add('pd-saved');
        btn.innerHTML = '<i class="fas fa-check"></i> Enregistré !';
    }

    socket.emit('update-profile', payload);
    popToast(t('toast.settings_saving'));

    setTimeout(() => {
        const menu = document.getElementById('profile-dropdown');
        if (menu) menu.style.display = 'none';
        if (btn) {
            btn.disabled = false;
            btn.classList.remove('pd-saved');
            btn.textContent = t('settings.save') || 'Enregistrer';
        }
    }, 700);
}

export function updateChatHeader(nom) {
    const header = document.getElementById('chat-header');
    const btnCall = document.getElementById('btn-call-mp');
    if (!header) return;

    header.style.color = "";
    const activeDestId = window.destinataireID || state.destinataireID;
    if (activeDestId === null) {
        header.innerHTML = t('chat.header_general');
        header.classList.add('header-general');
        header.classList.remove('header-private');
        if (btnCall) btnCall.style.display = 'none';
    } else if (activeDestId === state.monPseudo) {
        header.innerHTML = '📝 Notes personnelles';
        header.classList.add('header-private');
        header.classList.remove('header-general');
        if (btnCall) btnCall.style.display = 'none';
    } else {
        header.innerHTML = t('chat.header_mp', { pseudo: nom });
        header.classList.add('header-private');
        header.classList.remove('header-general');
        if (typeof window.majBoutonAppelMP === 'function') window.majBoutonAppelMP();
    }
}

socket.on('compte-supprime', () => {
    localStorage.clear();
    window.location.href = '/';
});

socket.on('mon-compte-info', ({ email, hasPassword }) => {
    const el = document.getElementById('params-field-email');
    if (el) el.textContent = email || '—';
    const mdpRow = document.getElementById('mdp-edit-toggle-row');
    if (mdpRow) mdpRow.style.display = hasPassword ? '' : 'none';
});

socket.on('email-change-result', (res) => {
    const msg = document.getElementById('email-change-msg');
    if (res.ok) {
        if (msg) { msg.style.color = '#3fb950'; msg.textContent = '✅ E-mail mis à jour.'; }
        popToast('✅ E-mail mis à jour.', 'success');
        toggleEditEmail(false);
        socket.emit('get-mon-compte');
    } else {
        if (msg) { msg.style.color = '#f85149'; msg.textContent = res.error || 'Erreur.'; }
    }
});

socket.on('mdp-change-result', (res) => {
    const msg = document.getElementById('mdp-change-msg');
    if (res.ok) {
        if (msg) { msg.style.color = '#3fb950'; msg.textContent = '✅ Mot de passe modifié.'; }
        popToast('✅ Mot de passe modifié.', 'success');
        toggleEditMotDePasse(false);
    } else {
        if (msg) { msg.style.color = '#f85149'; msg.textContent = res.error || 'Erreur.'; }
    }
});

export function toggleEditEmail(forceState) {
    const form = document.getElementById('email-edit-form');
    if (!form) return;
    const show = forceState !== undefined ? forceState : form.style.display === 'none';
    form.style.display = show ? 'flex' : 'none';
    if (show) {
        document.getElementById('edit-new-email')?.focus();
        const msg = document.getElementById('email-change-msg');
        if (msg) msg.textContent = '';
    }
}

export function changerEmail() {
    const newEmail = document.getElementById('edit-new-email')?.value.trim();
    const password = document.getElementById('edit-email-password')?.value;
    socket.emit('changer-email', { newEmail, password });
}

export function toggleEditMotDePasse(forceState) {
    const form = document.getElementById('mdp-edit-form');
    if (!form) return;
    const show = forceState !== undefined ? forceState : form.style.display === 'none';
    form.style.display = show ? 'flex' : 'none';
    if (show) {
        document.getElementById('edit-mdp-actuel')?.focus();
        const msg = document.getElementById('mdp-change-msg');
        if (msg) msg.textContent = '';
    } else {
        ['edit-mdp-actuel', 'edit-mdp-new', 'edit-mdp-confirm'].forEach(id => {
            const el = document.getElementById(id);
            if (el) el.value = '';
        });
    }
}

export function changerMotDePasse() {
    const currentPassword = document.getElementById('edit-mdp-actuel')?.value;
    const newPassword = document.getElementById('edit-mdp-new')?.value;
    const confirm = document.getElementById('edit-mdp-confirm')?.value;
    const msg = document.getElementById('mdp-change-msg');
    if (newPassword !== confirm) {
        if (msg) { msg.style.color = '#f85149'; msg.textContent = 'Les mots de passe ne correspondent pas.'; }
        return;
    }
    socket.emit('changer-mot-de-passe', { currentPassword, newPassword });
}

export function previewCouleurPseudo(val) {
    const pseudo = window.monPseudo || state.monPseudo;
    if (!pseudo) return;

    // Swatch dans le dropdown
    const sw = document.getElementById('swatch-pseudo');
    if (sw) sw.style.background = val;

    // Pseudos dans les messages déjà affichés
    document.querySelectorAll(`.message-author[data-pseudo="${pseudo}"]`).forEach(el => {
        el.style.color = val;
    });

    // Nom + avatar dans la barre des agents
    const liMoi = document.querySelector('.agent-item-moi');
    if (liMoi) {
        const agentName = liMoi.querySelector('.agent-name');
        if (agentName) agentName.style.color = val;
        const agentAvatar = liMoi.querySelector('.agent-mini-avatar');
        if (agentAvatar) {
            agentAvatar.style.borderColor = val;
            if (!agentAvatar.style.backgroundImage?.includes('url')) agentAvatar.style.color = val;
        }
    }

    // Avatar self flyout (si pas d'image)
    const selfAvatar = document.getElementById('self-avatar');
    if (selfAvatar && !selfAvatar.style.backgroundImage?.includes('url')) {
        selfAvatar.style.backgroundColor = val;
    }

    // Prévisualisation avatar dans le dropdown
    const pdAvatar = document.getElementById('pd-avatar-preview');
    if (pdAvatar && !pdAvatar.style.backgroundImage?.includes('url')) {
        pdAvatar.style.backgroundColor = val;
    }
}

export function initAccountSync() {
    // Rendu dynamique de la table des sessions actives (anti-session hijacking)
    socket.on('mes-appareils', ({ sessions, currentSessionId }) => {
        const list = document.getElementById('appareils-list');
        if (!list) return;
        if (!sessions.length) {
            list.innerHTML = `<div style="color:#484f58; font-size:0.85em;">${t('params.appareils_empty')}</div>`;
            return;
        }
        list.innerHTML = sessions.map(s => {
            const isCurrent = s.session_id === currentSessionId;
            const lastSeen = new Date(s.last_seen).toLocaleString();
            const createdAt = new Date(s.created_at).toLocaleDateString();
            return `
                <div class="appareil-card ${isCurrent ? 'appareil-current' : ''}">
                    <div class="appareil-icon"><i class="fas fa-${/iOS|Android/i.test(s.device_label) ? 'mobile-alt' : 'laptop'}"></i></div>
                    <div class="appareil-info">
                        <div class="appareil-label">${s.device_label || 'Navigateur inconnu'}
                            ${isCurrent ? `<span class="appareil-badge">${t('params.appareils_current')}</span>` : ''}
                        </div>
                        <div class="appareil-meta">IP : ${s.ip} · Connexion : ${createdAt} · Vu : ${lastSeen}</div>
                    </div>
                    ${!isCurrent ? `<button class="appareil-revoke-btn" onclick="window.revoquerAppareil('${s.session_id}')">${t('params.appareils_revoke')}</button>` : ''}
                </div>`;
        }).join('');
    });

    socket.on('appareil-revoque', () => { socket.emit('get-mes-appareils'); });
    socket.on('tous-appareils-revoques', () => { socket.emit('get-mes-appareils'); });

    socket.off('update-success');

    socket.on('update-success', () => {
        popToast(t('toast.settings_saved'), "success");
        const couleurInput = document.getElementById('edit-color');
        if (couleurInput) {
            state.maCouleur = couleurInput.value;
            window.maCouleur = couleurInput.value;
        }
        socket.emit('get-user-profile', window.monPseudo || state.monPseudo);
        socket.emit('demander-liste-maj');
    });

    socket.on('nom-affiche-result', (res) => {
        const msg = document.getElementById('nom-affiche-msg');
        const pseudo = window.monPseudo || state.monPseudo;
        if (res && res.ok) {
            if (state.utilisateurs && state.utilisateurs[pseudo]) state.utilisateurs[pseudo].nom_affiche = res.nom_affiche || null;
            if (msg) {
                msg.style.color = '#3fb950';
                msg.textContent = res.nom_affiche ? "✅ Nom d'affichage mis à jour." : "✅ Nom d'affichage retiré.";
            }
            popToast("✅ Nom d'affichage mis à jour.", 'success');
        } else if (msg) {
            msg.style.color = '#f85149';
            msg.textContent = (res && res.error) ? res.error : 'Échec de la mise à jour.';
        }
    });

    // Binding programmatique du bouton Enregistrer les paramètres
    const btnSave = document.getElementById('save-settings');
    if (btnSave) btnSave.onclick = enregistrerProfilAjuste;
}